import React, { FC } from 'react';
import { ISliderProps } from '../IntroSlider';
import IntroContainer from '../IntroContainer';

const MixGeneration: FC<ISliderProps> = ({currentSlider, nextSlide}) => {
  return (
    <IntroContainer
      imgContainer={(
        <div className="intro__logo">
          <div className="intro__logo-img intro__generation-img" />
        </div>
      )}
      nextSlide={nextSlide}
      textTitle="Возможность создавать и сохранять кастомные миксы"
      currentPage={currentSlider}
    />
  );
};

export default MixGeneration;
